import React from 'react';
import PropTypes from 'prop-types';
import { notification, Upload } from 'antd';
import { CameraOutlined, LoadingOutlined } from '@ant-design/icons';
import Button from '../../Button';
import { resizeImage, uploadToGoogleCloud } from '../../../utils/upload';
import styles from './styles.less';

const ImageUpload = ({
  uploadHandler,
  text,
  multiple,
  className,
  containerClassName,
  type,
  folder,
  withIcon,
  onClick,
}) => {
  const [loading, setLoading] = React.useState(false);
  return (
    <Upload
      multiple={multiple}
      accept="image/*"
      showUploadList={false}
      className={[styles.upload, containerClassName].join(' ')}
      customRequest={({ file }) => {
        setLoading(true);
        resizeImage({
          maxWidth: 800,
          file,
        })
          .then(({ file: res }) => {
            uploadToGoogleCloud(type, folder, res)
              .then(url => {
                uploadHandler(url);
                setLoading(false);
              })
              .catch(() => {
                notification.error({
                  message: 'Something went wrong, please try later.',
                });
                setLoading(false);
              });
          })
          .catch(() => {
            notification.error({
              message: 'Something went wrong, please try later.',
            });
            setLoading(false);
          });
      }}
    >
      <Button type="primary" id="upload" onClick={onClick} className={className}>
        {(loading && <LoadingOutlined />) || (withIcon && <CameraOutlined />) || null}
        <span>{text}</span>
      </Button>
    </Upload>
  );
};

ImageUpload.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  multiple: PropTypes.bool,
  folder: PropTypes.string,
  withIcon: PropTypes.bool,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  uploadHandler: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

ImageUpload.defaultProps = {
  text: '',
  className: '',
  type: 'school',
  withIcon: false,
  multiple: false,
  folder: 'course',
  containerClassName: '',
  onClick: () => { },
};

export default ImageUpload;
